var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"mr-2 text-center",attrs:{"size":"sm","variant":_vm.variant,"disabled":_vm.disabled}},[(!_vm.disabled || _vm.hasLoad)?[_vm._t("default")]:_vm._e(),(_vm.disabled && !_vm.hasLoad)?[_c('i',{staticClass:"fas fa-spinner fa-pulse",staticStyle:{"font-size":"15px"}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }